import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import BalanceCalculations from '@components/BalanceCalculations'

import type { CampaignModel } from '@models/types'

import type { OrderReconciliationPayload } from '../../hooks/useOrderReconciliation'

import OrderReconciliationListItem from './OrderReconciliationListItem'

type OrderReconciliationListPops = {
  campaign: CampaignModel,
  providerSelected: boolean,
  title?: string,
  orderReconciliationPayload: OrderReconciliationPayload,
}

const OrderReconciliationList = (props: OrderReconciliationListPops) => {
  const {
    campaign, providerSelected, orderReconciliationPayload, title,
  } = props

  const { title: campaignTitle } = campaign

  const {
    callbacks: { editReconciliationItem },
    orderReconciliationItems: {
      items,
    },
  } = orderReconciliationPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      title={title || campaignTitle}
    >
      <Box flexDirection="column">
        {items.map(item => (
          <OrderReconciliationListItem
            // @ts-expect-error TS2345
            callbacks={{ editItem: () => editReconciliationItem(item) }}
            item={item}
            key={item.id}
          />
        ))}
      </Box>

      {providerSelected && (
        <Box borderTop="1px solid" borderColor="lineColor" padding="large">
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faDownload} />}
            onClick={() => console.log('To Do Provider cost of sale')}
            size="medium"
            // @ts-expect-error
            width={['100%', 'fit-content']}
          >
            Download
          </Button>
        </Box>
      )}

      {!providerSelected && (
        <BalanceCalculations campaign={campaign} orderReconciliationPayload={orderReconciliationPayload} />
      )}
    </DashboardModule>
  )
}

export default OrderReconciliationList
